import {currentTierScopeCopy} from './customTierCopy.js'
/** Customer scope describes the work; individual selling prices remain internal.
 * Apply at presentation/export and when creating a new signed agreement, never
 * mutate an existing signed document or the underlying pricing calculations. */
export function customerPackageScope(scope: readonly string[]): string[] {
  return scope.map(currentTierScopeCopy).map(line => {
    if (/^Delivery allowance(?: basis)?:\s*\$?[\d,.]+\s*·\s*included in package pricing$/i.test(line)) {
      return 'Delivery included in package pricing'
    }
    return line.replace(/(?:U[-–— ]shaped(?: lower)? shiplap(?: enclosure)?|Lower bunk shiplap enclosure|Lower shiplap enclosure)/gi, 'Accent wall shiplap').split(' · ').map(part => part
      .replace(/\s*[×x]\s*\$[\d,]+(?:\.\d+)?(?:\s*estimated)?/g, '')
      .replace(/\+?\$[\d,]+(?:\.\d+)?(?:\s*(?:each|per (?:bed|set|unit)|estimated))?/gi, '')
      .replace(/\(\s*\)/g, '')
      .trim()
    ).filter(Boolean).join(' · ')
  }).filter(Boolean)
}
